import axios from '@/libs/api.request'

/**
 * 添加设备用户
 */
export const addDeviceUser = (device_type, device_id, user_ids) => {
    const data ={
        "device_type": device_type,
        "device_id": device_id,
        "user_ids": user_ids
    }
    return axios.request({
        url: '/api/admin/deviceuser/save',
        data,
        method: 'post'
    })
}

/**
 * 获取所有数据采集器 根据工程
 */
export const getAllDeviceCheckList = () => {
    return axios.request({
        url: '/api/admin/devicecheck/getAllDeviceCheckList',
        method: 'post'
    })
}

/**
 * 获取所有非接触设备 根据工程
 */
 export const getAllDeviceExtractList = () => {
    return axios.request({
        url: '/api/admin/deviceextract/getAllDeviceExtractList',
        method: 'post'
    })
}

/**
 * 获取所有灌浆记录仪 根据工程
 */
 export const getAllDeviceWorkList = () => {
    return axios.request({
        url: '/api/admin/devicework/getAllDeviceWorkList',
        method: 'post'
    })
}

/**
 * 获取生产厂商列表
 */
export const getAllProducerList = () => {
    return axios.request({
        url: '/api/admin/producer/producerList',
        method: 'post'
    })
}

/**
 * 获取设备列表
 */
export const getFlowMeterList = (type) => {
    const data ={
        "type": type
    }
    return axios.request({
        url: '/api/admin/flowmeter/flowmeterList',
        data,
        method: 'post'
    })
}

/**
 * 获取路由器列表
 */
export const getRoutersList = () => {
    
    return axios.request({
        url: '/api/admin/routers/routersList',
        method: 'post'
    })
}

/**
 * 获取物联网卡列表
 */
export const getNetCardList = () => {
    return axios.request({
        url: '/api/admin/netcard/cardList',
        method: 'post'
    })
}

/**
 * 数据采集器借调
 */
export const deviceCheckBorrow = (device_id, project_id) => {
    const data ={
        "device_id": device_id,
        "project_id": project_id,
    }
    return axios.request({
        url: '/api/admin/devicecheck/borrow',
        data,
        method: 'post'
    })
}

/**
 * 非接触借调
 */
export const deviceExtactBorrow = (device_id, project_id) => {
    const data ={
        "device_id": device_id,
        "project_id": project_id,
    }
    return axios.request({
        url: '/api/admin/deviceextract/borrow',
        data,
        method: 'post'
    })
}

/**
 * 流量计、压力计、密度计、下位机借调
 */
export const flowMeterBorrow = (device_id, project_id) => {
    const data ={
        "device_id": device_id,
        "project_id": project_id,
    }
    return axios.request({
        url: '/api/admin/flowmeter/borrow',
        data,
        method: 'post'
    })
}

/**
 * 路由器借调
 */
export const routersBorrow = (device_id, project_id) => {
    const data ={
        "device_id": device_id,
        "project_id": project_id,
    }
    return axios.request({
        url: '/api/admin/routers/borrow',
        data,
        method: 'post'
    })
}

/**
 * 物联网卡借调
 */
export const netCardBorrow = (device_id, project_id) => {
    const data ={
        "device_id": device_id,
        "project_id": project_id,
    }
    return axios.request({
        url: '/api/admin/netcard/borrow',
        data,
        method: 'post'
    })
}

/**
 * 平板电脑借调
 */
export const tabletsBorrow = (device_id, project_id) => {
    const data ={
        "device_id": device_id,
        "project_id": project_id,
    }
    return axios.request({
        url: '/api/admin/tablets/borrow',
        data,
        method: 'post'
    })
}